import { render } from "./BackBar.vue?vue&type=template&id=ed0e33dc&scoped=true&ts=true"
import script from "./BackBar.vue?vue&type=script&lang=ts"
export * from "./BackBar.vue?vue&type=script&lang=ts"

import "./BackBar.vue?vue&type=style&index=0&id=ed0e33dc&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed0e33dc"]])

export default __exports__